import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type StoreSearchReducedFragment = { __typename?: 'StoreSearchResult', id: string, name?: string | null, store?: { __typename?: 'Store', id: string, name?: string | null, external_vytal_id?: string | null, brand_id?: string | null } | null };

export type StoreSearchStoreReducedFragment = { __typename?: 'Store', id: string, name?: string | null, external_vytal_id?: string | null, brand_id?: string | null };

export const StoreSearchStoreReducedFragmentDoc = gql`
    fragment StoreSearchStoreReduced on Store {
  id
  name
  external_vytal_id
  brand_id
}
    `;
export const StoreSearchReducedFragmentDoc = gql`
    fragment StoreSearchReduced on StoreSearchResult {
  id
  name
  store {
    ...StoreSearchStoreReduced
  }
}
    ${StoreSearchStoreReducedFragmentDoc}`;